export default "__VITE_ASSET__C8Jpmfxp__"